import React, { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Eraser } from "lucide-react";

// Captures signature strokes normalized to a 600x200 SVG coordinate space.
export default function SignaturePad({ onChange }) {
  const svgRef = useRef(null);
  const [paths, setPaths] = useState([]);
  const [current, setCurrent] = useState(null);
  const drawing = useRef(false);

  const toCoords = (e) => {
    const rect = svgRef.current.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    const x = ((clientX - rect.left) / rect.width) * 600;
    const y = ((clientY - rect.top) / rect.height) * 200;
    return [Math.round(x * 10) / 10, Math.round(y * 10) / 10];
  };

  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const [x, y] = toCoords(e);
    setCurrent(`M ${x} ${y}`);
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const [x, y] = toCoords(e);
    setCurrent((c) => `${c} L ${x} ${y}`);
  };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    const c = current;
    if (c && c.includes("L")) {
      const next = [...paths, c];
      setPaths(next);
      onChange && onChange(next);
    }
    setCurrent(null);
  };

  const clear = () => {
    setPaths([]);
    setCurrent(null);
    onChange && onChange([]);
  };

  return (
    <div>
      <svg
        ref={svgRef}
        viewBox="0 0 600 200"
        className="w-full h-40 border border-slate-300 rounded-lg bg-white touch-none cursor-crosshair"
        data-testid="signature-pad"
        onMouseDown={start}
        onMouseMove={move}
        onMouseUp={end}
        onMouseLeave={end}
        onTouchStart={start}
        onTouchMove={move}
        onTouchEnd={end}
      >
        {paths.map((d, i) => (
          <path key={i} d={d} fill="none" stroke="#0f172a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        ))}
        {current && <path d={current} fill="none" stroke="#0f172a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />}
      </svg>
      <Button type="button" variant="ghost" size="sm" onClick={clear} data-testid="signature-clear" className="mt-1 text-slate-500">
        <Eraser className="h-4 w-4 mr-1" /> Löschen
      </Button>
    </div>
  );
}
